import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ColDef, ColumnApi, GetRowIdFunc, GetRowIdParams, GridApi, GridOptions } from 'ag-grid-community';
import { Subscription } from 'rxjs';
import { CrewsService, ICrew } from 'src/app/contracts/crews.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/shared-components/confirm-dialog/confirm-dialog.component';
import { AgGridSettings, UserSettingsService } from 'src/app/user-settings/user-settings.service';

@Component({
  selector: 'app-crews',
  templateUrl: './crews.component.html',
  styleUrls: ['./crews.component.scss']
})
export class CrewsComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  reps: ICrew[] = [];
  selectedCrew: ICrew | null = null;

  gridApi: GridApi | undefined;
  gridColumnApi: ColumnApi | undefined;
  gridOptions: GridOptions = {};
  agGridTheme = 'ag-theme-balham';
  gridActivated = false;
  defaultColDef: any;
  cols: ColDef[] = [];

  filterParams = {
    comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
      if (cellValue === null) return -1;
      const cellDate = new Date(cellValue);
      if (filterLocalDateAtMidnight.getTime() == cellDate.getTime()) { return 0 }
      if (cellDate < filterLocalDateAtMidnight) { return -1; }
      if (cellDate > filterLocalDateAtMidnight) { return 1; }
      return -1
    },
    browserDatePicker: true,
    buttons: ['reset', 'apply']
  };


  crewForm = this.fb.group({
    Id: [0],
    Name: ['', Validators.required],
  });


  constructor(private repsService: CrewsService, private fb: FormBuilder, private userSettings: UserSettingsService,private dialog: MatDialog) {
    this.subscriptions.add(this.userSettings.agGridSettings.subscribe(data => {
      this.initGrid(data);
    }));
  }

  ngOnInit(): void {
    this.repsService.crews.subscribe(data => this.reps = data);

  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }


  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onSelectionChanged() {
    const selectedRows = this.gridApi?.getSelectedRows() ?? [];
    if (selectedRows?.length > 0) {
      const selectedRep = selectedRows[0] as ICrew;
      this.resetForm();
      this.selectedCrew = { ...selectedRep };
      this.crewForm.setValue(this.selectedCrew);
    }
  }

  clearFilters() {
    this.gridOptions.api?.setFilterModel(null);
    this.gridApi?.onFilterChanged();
  }

  initGrid(data: AgGridSettings) {
    this.gridActivated = false;
    const { theme, ...gridOptions } = data;
    this.gridOptions = gridOptions;
    this.agGridTheme = theme;
    this.gridOptions.getRowId = (params: GetRowIdParams) => params.data.Id;

    this.defaultColDef = {
      filter: 'agTextColumnFilter',
      resizable: true,
      sortable: true,
      cellStyle: { 'line-height': `${(data.rowHeight ?? 20) - 4}px` },
      floatingFilter: true,
      filterParams: {
        debounceMs: 1
      },
    };

    this.cols = [
      { field: 'Name', headerName: 'Name', flex: 1 },
    ];
    setTimeout(() => { this.gridActivated = true; }, 1);
  }

  resetForm() {
    this.selectedCrew = null;
    this.crewForm = this.fb.group({
      Id: [0],
      Name: ['', Validators.required],
    });
  }


  newCrew() {
    this.selectedCrew = null;
    this.resetForm();
    this.gridApi?.deselectAll();
  }

  saveCrew() {
    if (!this.crewForm.valid) {
      this.crewForm.markAllAsTouched();
      return;
    }

    const crew = this.crewForm.value as ICrew;
    this.repsService.saveCrew(crew).subscribe(data => {
      setTimeout(() => {
        this.gridApi?.forEachNode(node => node.data.Id === data.Id ? node.setSelected(true, true) : null);
      }, 50);
    });

    this.resetForm();
  }

  deleteCrew() {
    if (this.selectedCrew === null) { return; }

    const message = `Are you sure you want to delete crew: '${this.selectedCrew.Name}' ?`;
    const dialogData = new ConfirmDialogModel("Confirm Delete", message);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        if (this.selectedCrew !== null) {
          this.repsService.delete(this.selectedCrew).subscribe(data => this.resetForm());
        }
      }
    });
  }
}
